import { render } from "./appVersionModule.vue?vue&type=template&id=a46bb968"
import script from "./appVersionModule.vue?vue&type=script&lang=js"
export * from "./appVersionModule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__